<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<card>
					<StopPunctualityReportTable></StopPunctualityReportTable>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import StopPunctualityReportTable from '@/components/Report/StopPunctualityReportTable.vue';

export default {
	name: 'StopPunctualityReport',
	components: {
		StopPunctualityReportTable
	}
};
</script>
